$(function () {

    $('#readmore').on('click', function(e){
        e.preventDefault();

        let $description = $(".description.bottom"),
            $read = $("#readmore"),
            $cache = $(".cache");

        $description.toggleClass('open');
        $cache.toggleClass('opa-0');

        $description.hasClass('open') ? $read.html('Moins de détails') : $read.html('Plus de détails')
    })


    var $root = $("html, body");
    setTimeout(function(){
         $("body").on("click", "#srw-link", function (e) {
            e.preventDefault();
            $root.stop().animate({ scrollTop: $(".block-srw").offset().top - 70 }, 600);
            //return !1;
        });
     }, 1000)
   
    if ($(window).width() > 480 && $(window).width() <= 1039) {
        $('#header [data-dropdown-rel="menu"]').on("click", function () {
            $(this).find("div").toggleClass("blb");
            $('[data-dropdown="menu"]').toggleClass("show");
            $('[data-dropdown="menu"]').attr("style", "");
        });
    }
    if ($(window).innerWidth() <= 576) {
        $(".sidebar-wrap").hide();
        $(".sidebar").prepend('<div class="filter-mobile">filtres</div>');
        $(".filter-mobile").on("click", function () {
            $(".sidebar-wrap").toggle("slow", function () {
                $(".filter-mobile").text($(".filter-mobile").text() == "filtres" ? "masquer les filtres" : "filtres");
            });
        });
    }
    $(".flex-link").on("click", function (e) {
        e.preventDefault();
        $(".js-trust-lightbox, .trust-wrap").show();
    });
    $(".js-trust-lightbox").on("click", function () {
        $(".js-trust-lightbox, .trust-wrap").hide();
    });
    $(".js-trust-close").on("click", function () {
        $(".js-trust-lightbox, .trust-wrap").hide();
    });
    $(".trust-wrap").on("click", function (e) {
        e.stopPropagation();
    });
    $("ul.tabs").each(function () {
        var active,
            content,
            links = $(this).find("a");
        active = links.first().addClass("active");
        content = $(active.attr("href"));
        links.not(":first").each(function () {
            $($(this).attr("href")).hide();
        });
        $(this)
            .find("a")
            .click(function (e) {
                active.removeClass("active");
                content.hide();
                active = $(this);
                content = $($(this).attr("href"));
                active.addClass("active");
                content.show();
                return !1;
            });
    });
      // Gestion des flèches du slider mobile
    document.addEventListener("DOMContentLoaded", function () {
        var mobileSlider = document.getElementById("mobile-slider-{{ section.id }}");

        if (mobileSlider) {
            var showArrows = mobileSlider.getAttribute("data-arrow") === "true";

            // Initialise Flickity avec ou sans les flèches
            var flkty = new Flickity(mobileSlider, {
                prevNextButtons: showArrows, // Active/désactive les flèches
                pageDots: true,
                wrapAround: true
            });

            console.log("Slider mobile initialisé avec flèches :", showArrows);
        }
    });

});
